export default {"src":"/kaimono/_next/static/media/close_icon.6b0bee09.svg","height":11,"width":10};